import { useContext } from 'react';
import AppContext from '../../AppContext';
import { appConfig } from '../../config';

function Artikelzusatz() {
  const { appData } = useContext(AppContext);

  return (
    <div className="configurator__artikelzusatz">
      <div className="row stock-information stock-information-p no-gutters">
        <div className="col">
          <div className="delivery-status">
            <ul className="list-unstyled">
              {appData.static.artikel.lieferstatus
                && (
                  <li>
                    <div className="delivery-status">Lieferstatus: {appData.static.artikel.lieferstatus}</div>
                  </li>
                )}
              {(appData.static.artikel.lieferzeit || appData.static.artikel.lieferzeitErsterKindArtikel)
                && (
                  <li>
                    <div
                      className="estimated-delivery"
                      data-toggle="popover"
                      data-placement="top"
                      data-content="Die angegebenen Lieferzeiten gelten für den Versand innerhalb Deutschlands. Weitere Informationen
                        finden sie in der <a href='Deutschland'>Versandinformationen</a>."
                      data-original-title=""
                      title=""
                    >
                      Lieferzeit:&nbsp;
                      <span className="a2">
                        {appData.static.artikel.lieferzeit ?? appData.static.artikel.lieferzeitErsterKindArtikel}&nbsp;
                        <span className="estimated-delivery-info">(Ausland abweichend)</span>
                      </span>
                    </div>
                  </li>
                )}
            </ul>
          </div>
        </div>
        { !appConfig.external
          && (
            <div className="col question-on-item col-auto">
              <button
                type="button"
                id={`z${appData.static.artikel.kArtikel}`}
                className="btn btn-link question"
                title="Frage zum Artikel"
                data-toggle="modal"
                data-target={`#question-popup-${appData.static.artikel.kArtikel}`}
              >
                <span className="fa fa-question-circle" />&nbsp;
                <span className="hidden-xs hidden-sm">Frage zum Artikel</span>
              </button>
            </div>
          )}
      </div>
    </div>
  );
}

export default Artikelzusatz;
